export default __webpack_public_path__ + "static/media/veggie.4c190200.svg";